import { observer } from "mobx-react-lite"

import { Button } from "@/components/button"
import { DisplayTokenRow } from "@/domains/common/components/display-token-row"
import { cn } from "@/domains/library"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { DisplayMinimalPool } from "@/domains/minimal-pool/components/display-minimal-pool"
import { showDisplayType } from "@/lib/show-display-type"

export const StoreTabletFeesView = observer(
  ({ pools, onClaimLpFees }: { pools: Array<MinimalPoolStore>; onClaimLpFees: (pool: MinimalPoolStore) => void }) => {
    return (
      <div className="overflow-hidden rounded-t-xl border border-p400-light ">
        <div
          className={cn(
            "bg-p400 px-4 text-t200",
            "grid grid-cols-[1fr_1fr_20%]",
            "items-center justify-between gap-4 px-4 py-2 text-sm",
          )}
        >
          <div className="text-left">Pool</div>

          <div className="text-right">Earned</div>
          <div className="text-center">Action</div>
        </div>

        {pools.map((pool) => {
          return (
            <div
              key={pool.address.toString()}
              className={cn(
                "border-b border-p400-light bg-p400 px-4 py-4 text-sm text-t200",
                "grid grid-cols-[1fr_1fr_20%] gap-4",
              )}
            >
              <div className="flex items-start md:w-1/4">
                <DisplayMinimalPool
                  pool={pool}
                  label={showDisplayType(pool.displayType, true, true)}
                  className="flex-row items-start"
                />
              </div>
              <div className="flex flex-col items-end justify-center text-xs">
                <DisplayTokenRow token={pool.token0} amount={pool.onChainUserClaimableFees0} />
                <DisplayTokenRow token={pool.token1} amount={pool.onChainUserClaimableFees1} />
              </div>

              <div className="flex justify-center">
                <Button
                  title="Claim fees"
                  onClick={() => {
                    void onClaimLpFees(pool)
                  }}
                  variant="percentage"
                >
                  Claim
                </Button>
              </div>
            </div>
          )
        })}
      </div>
    )
  },
)
